/**
 * Brand Icons
 *
 * Third-party brand logos used throughout the app (Google Drive, Dropbox, etc.)
 */

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faGoogleDrive,
  faDropbox,
  faGoogle,
  faApple,
  faAndroid,
  faStrava,
  faCcVisa,
  faCcMastercard,
  faCcAmex,
  faCcDinersClub,
  faCcDiscover,
  faCcJcb
} from '@fortawesome/free-brands-svg-icons';

export const loadBrandIcons = () => {
  library.add(
    faGoogleDrive,
    faDropbox,
    faGoogle,
    faApple,
    // Health sources sheet (works-with tiles)
    faAndroid,
    faStrava,
    faCcVisa,
    faCcMastercard,
    faCcAmex,
    faCcDinersClub,
    faCcDiscover,
    faCcJcb,
  );
};
